export type ThemeChoice = 'light' | 'dark' | 'system';

const KEY = 'poptown.theme';
// tema e dimensione si cambiano dall'intestazione e da Impostazioni › Aspetto: l'evento le tiene
// allineate
export const APPEARANCE_EVENT = 'poptown-appearance';

export function readTheme(): ThemeChoice {
  const v = localStorage.getItem(KEY);
  return v === 'light' || v === 'dark' || v === 'system' ? v : 'system';
}

export function resolved(choice: ThemeChoice): 'light' | 'dark' {
  if (choice !== 'system') return choice;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(choice: ThemeChoice): void {
  const r = resolved(choice);
  document.documentElement.dataset.theme = r;
  document
    .querySelector('meta[name=theme-color]')
    ?.setAttribute('content', r === 'dark' ? '#1B1533' : '#F5F0FF');
  localStorage.setItem(KEY, choice);
  window.dispatchEvent(new Event(APPEARANCE_EVENT));
}

export function watchSystem(choice: ThemeChoice, cb: () => void): () => void {
  if (choice !== 'system') return () => undefined;
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  mq.addEventListener('change', cb);
  return () => mq.removeEventListener('change', cb);
}

// Dimensione dell'interfaccia: la sceglie la persona per il suo schermo (un 4K scalato da
// macOS e uno a 100% vogliono valori opposti, la larghezza in pixel non basta a deciderlo).
export const SCALES = [0.67, 0.8, 0.9, 1, 1.15, 1.3] as const;
const SCALE_KEY = 'poptown.scale';

export function readScale(): number {
  const v = Number(localStorage.getItem(SCALE_KEY));
  return (SCALES as readonly number[]).includes(v) ? v : 1;
}

export function applyScale(v: number): void {
  document.documentElement.style.setProperty('--zoom', String(v));
  localStorage.setItem(SCALE_KEY, String(v));
  window.dispatchEvent(new Event(APPEARANCE_EVENT));
}
